/**
 * デッキの並べ替え。
 *
 * 表示はメインデッキとエクストラデッキの2つのグリッドに分かれているが、
 * 並び順は1本の配列で持っている。添字は**平坦配列**のもので、
 * 中身が入れ替わる（バージョンのプレビュー・整列・再読込）と別のカードを指す。
 */

/**
 * fromIdx のカードを toIdx の位置へ動かした新しい配列を返す。
 * 動かせない指定のときは元の配列をそのまま返す（呼び出し側で同一性を見て
 * 変更の有無を判定できる）。
 *
 * 範囲チェックは必須。fromIdx が範囲外だと splice が空配列を返し、
 * undefined が並びに混ざって、次の描画でカードの種別判定が落ちる。
 */
export function moveInList(list, fromIdx, toIdx) {
  if (!Array.isArray(list)) return list;
  if (fromIdx === null || toIdx === null || fromIdx === toIdx) return list;
  if (fromIdx < 0 || fromIdx >= list.length) return list;
  if (toIdx < 0 || toIdx >= list.length) return list;
  const next = [...list];
  const [item] = next.splice(fromIdx, 1);
  next.splice(toIdx, 0, item);
  return next;
}

/**
 * 平坦配列上で、同じセクション（メイン/エクストラ）の隣の添字。
 *
 * 別セクションと入れ替えても表示は2つのグリッドに分かれたままなので
 * 見た目が変わらず、「押しても無反応なのに保存だけ要求される」ことになる。
 *
 * @param {Array} list
 * @param {number|null} idx
 * @param {1|-1} dir
 * @param {(card:any) => boolean} isExtra セクションの判定
 * @returns {number|null} 見つからなければ null
 */
export function neighborInSection(list, idx, dir, isExtra) {
  if (!Array.isArray(list) || idx === null || !list[idx]) return null;
  const section = isExtra(list[idx]);
  for (let i = idx + dir; i >= 0 && i < list.length; i += dir) {
    if (isExtra(list[i]) === section) return i;
  }
  return null;
}
